import Reveal from "@/components/Reveal";

export default function ReviewsEmpty() {
  return (
    <section className="py-20 px-6 max-w-6xl mx-auto" data-testid="reviews-section">      <Reveal>
      <div className="border border-white/10 rounded-2xl p-8 sm:p-12 bg-[#061536]/40 text-center">
        <span className="font-mono-lbl text-xs text-[#00F0FF] uppercase tracking-widest block mb-2">Architect & Client Voices</span>
        <h3 className="font-disp text-2xl sm:text-3xl uppercase mb-3">Verified Project Reviews</h3>
        <p className="text-white/60 text-sm max-w-md mx-auto" data-testid="reviews-empty-text">
          Reviews from our inaugural smart township deployments and private estates across India will be published here.
        </p>
      </div>
      </Reveal>
    </section>
  );
}
